import type { RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "gestion/sitio",
    component: () => import("./pages/SiteLayout.vue"),
    meta: {
      requiresAuth: true,
      requiresStaff: true,
      forceActiveMenu: "site-pages",
    },
    children: [
      {
        path: "",
        redirect: { name: "site-pages" },
      },
      {
        path: "paginas",
        name: "site-pages",
        component: () => import("./pages/StaticPagesList.vue"),
        meta: {
          requiresAuth: true,
          requiresStaff: true,
          titleKey: "site.pages_title",
          forceActiveMenu: "site-pages",
        },
      },
      {
        path: "paginas/nueva",
        name: "site-page-new",
        component: () => import("./pages/StaticPageEdit.vue"),
        meta: {
          requiresAuth: true,
          requiresStaff: true,
          titleKey: "site.page_new",
          forceActiveMenu: "site-pages",
        },
      },
      {
        path: "paginas/:id",
        name: "site-page-edit",
        component: () => import("./pages/StaticPageEdit.vue"),
        meta: {
          requiresAuth: true,
          requiresStaff: true,
          titleKey: "site.page_edit",
          forceActiveMenu: "site-pages",
        },
      },
      {
        path: "noticias",
        name: "site-news",
        component: () => import("./pages/NewsList.vue"),
        meta: {
          requiresAuth: true,
          requiresStaff: true,
          titleKey: "site.news_title",
          forceActiveMenu: "site-pages",
        },
      },
      {
        path: "noticias/nueva",
        name: "site-news-new",
        component: () => import("./pages/NewsEdit.vue"),
        meta: {
          requiresAuth: true,
          requiresStaff: true,
          titleKey: "site.news_new",
          forceActiveMenu: "site-pages",
        },
      },
      {
        path: "noticias/:id",
        name: "site-news-edit",
        component: () => import("./pages/NewsEdit.vue"),
        meta: {
          requiresAuth: true,
          requiresStaff: true,
          titleKey: "site.news_edit",
          forceActiveMenu: "site-pages",
        },
      },
      {
        path: "menu",
        name: "site-menu",
        component: () => import("./pages/MenuEditor.vue"),
        meta: {
          requiresAuth: true,
          requiresStaff: true,
          titleKey: "site.menu_title",
          forceActiveMenu: "site-pages",
        },
      },
    ],
  },
];

export const publicRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("./pages/public/PublicLayout.vue"),
    meta: { public: true },
    children: [
      {
        path: "",
        name: "public-home",
        component: () => import("./pages/public/PublicNews.vue"),
        meta: { public: true, publicHome: true },
      },
      {
        path: "noticias",
        name: "public-news",
        component: () => import("./pages/public/PublicNews.vue"),
        meta: { public: true },
      },
      {
        path: "noticias/:slug",
        name: "public-news-detail",
        component: () => import("./pages/public/PublicNewsDetail.vue"),
        meta: { public: true },
      },
      {
        path: "p/:slug",
        name: "public-page",
        component: () => import("./pages/public/PublicStaticPage.vue"),
        meta: { public: true },
      },
      {
        path: "actividades",
        name: "public-activities",
        component: () => import("./pages/public/PublicActivities.vue"),
        meta: { public: true },
      },
      {
        path: "vantaxes",
        name: "public-benefits",
        component: () => import("./pages/public/PublicBenefits.vue"),
        meta: { public: true },
      },
      {
        path: "mapa-do-sitio",
        name: "public-sitemap",
        component: () => import("./pages/public/PublicSitemap.vue"),
        meta: { public: true },
      },
      {
        path: "login",
        name: "login",
        component: () => import("@/modules/Users/pages/Login.vue"),
        meta: { public: true, guestOnly: true, title: "auth.title" },
      },
      {
        path: "register",
        name: "register",
        component: () => import("@/modules/Auth/pages/Register.vue"),
        meta: { public: true, guestOnly: true, title: "auth.register_page_title" },
      },
      {
        path: "finish-registration",
        name: "verify-email",
        component: () => import("@/modules/Auth/pages/FinishRegistration.vue"),
        meta: { public: true, guestOnly: true, title: "auth.finish_registration_title" },
      },
      {
        path: "forgot-password",
        name: "forgot-password",
        component: () => import("@/modules/Auth/pages/ForgotPassword.vue"),
        meta: { public: true, guestOnly: true, title: "auth.recover_page_title" },
      },
      {
        path: "reset-password",
        name: "reset-password",
        component: () => import("@/modules/Auth/pages/ResetPassword.vue"),
        meta: { public: true, guestOnly: true, title: "auth.reset_page_title" },
      },
    ],
  },
];
